<script lang="ts" setup>
import { EvaluationResults, TokenData } from "types/EvaluationResults";
import { EvaluationTest } from "types/EvaluationTest";

const props = defineProps({
  evaluationTest: {
    type: Object as PropType<EvaluationTest>,
    required: true,
  },
  evaluationResults: {
    type: Object as PropType<EvaluationResults>,
    required: true,
  },
});

const isLoading = computed(() => {
  return [
    EvaluationResultsStatus.evaluating,
    EvaluationResultsStatus.processing,
  ].includes(props.evaluationResults.status);
});

const isSuccess = computed(() => {
  return props.evaluationResults.status == EvaluationResultsStatus.success;
});

const isFailed = computed(() => {
  return props.evaluationResults.status == EvaluationResultsStatus.failed;
});

const evaluationTestResultsStore = useEvaluationTestResults(
  props.evaluationTest
)();

const {
  isTheExpectedResults,
  isResultsExpected,
  hasExpectedResults,
  expectedResults,
} = storeToRefs(evaluationTestResultsStore);

const isSettingExpectedResults = ref(false);
const setExpectedResults = async () => {
  isSettingExpectedResults.value = true;

  await evaluationTestResultsStore.setEvaluationExpectedResults(
    props.evaluationResults
  );

  isSettingExpectedResults.value = false;

  useBaseToast("Success!", "success");
};

const showExpectedResults = ref(false);
const toggleShowExpectedResults = () => {
  showExpectedResults.value = !showExpectedResults.value;
};

const showTokenData = ref(false);
const toggleShowTokenData = () => {
  showTokenData.value = !showTokenData.value;
};
</script>

<template>
  <div class="p-2 border-b last:border-b-0">
    <BaseLoading v-if="isLoading" />
    <div
      v-if="isFailed"
      class="w-full text-danger-default text-center p-4 italic"
    >
      Test Failed
    </div>
    <div v-if="isSuccess" class="flex flex-col">
      <DocumentProblemReviewTestingCompareResults
        :evaluation-results="evaluationResults"
        :expected-results="expectedResults"
        :show-expected-results="showExpectedResults"
        :show-token-data="showTokenData"
        @set-expected-results="setExpectedResults"
      />

      <div
        class="flex flex-row items-center my-2 text-[12px] justify-between"
        v-if="evaluationResults.tokenData"
      >
        <BaseTextButton class="text-[12px]" @click="toggleShowTokenData">
          {{ showTokenData ? "Hide" : "Show" }} Token Data
        </BaseTextButton>
        <span
          >Spacy Version: {{ evaluationResults.environment.spacyVersion }}</span
        >
      </div>
      <div
        class="flex flex-row items-center justify-between w-full mt-2"
        v-if="isTheExpectedResults(evaluationResults) != true"
      >
        <span v-if="hasExpectedResults != true"></span>

        <span
          class="flex flex-row items-center"
          v-if="
            hasExpectedResults == true &&
            isTheExpectedResults(evaluationResults) != true
          "
        >
          <span
            :class="{
              'text-danger-default':
                isResultsExpected(evaluationResults) == false,
              'text-success-default':
                isResultsExpected(evaluationResults) == true,
            }"
          >
            {{
              isResultsExpected(evaluationResults) == true
                ? "Results Expected"
                : "Results Not Expected"
            }}
          </span>
          <span class="mx-2">|</span>
          <BaseTextButton @click="toggleShowExpectedResults">
            {{ showExpectedResults ? "Hide Comparisson" : "Show Comparisson" }}
          </BaseTextButton>
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
